"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp;

var EventNotifications = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(EventNotifications, _Component);

  function EventNotifications() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, EventNotifications);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(EventNotifications)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "profile", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "config", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "markInvalid", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "markValid", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "id", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      messageEvents: _this.profile.messageEvents,
      smsNumber: _this.profile.smsNumber
    };
    return _this;
  }

  babelHelpers.createClass(EventNotifications, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.profile != this.props.profile) {
        this.setState({
          messageEvents: this.props.profile.messageEvents,
          smsNumber: this.props.profile.smsNumber
        });
      }
    }
  }, {
    key: "setValue",
    value: function setValue(event) {
      var _this2 = this;

      this.setState(babelHelpers.defineProperty({}, event.target.name, event.target.value), function () {
        if (_this2.state.messageEvents == 'sms' || _this2.state.messageEvents == 'emailAndSms') {
          if (_this2.state.smsNumber.replace(/ /g, '').length == 0 || _this2.state.smsNumber.replace(/[0-9 \(\)\.\+\-]/g, '').length) {
            _this2.markInvalid(_this2.id);
          } else {
            _this2.markValid(_this2.id);
          }
        } else {
          _this2.markValid(_this2.id);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, _react.default.createElement("div", {
        "data-field": "messageEvents",
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "messageEvents"
      }, "Event Reminders"), _react.default.createElement("div", {
        className: "select-wrap"
      }, _react.default.createElement("select", {
        id: "messageEvents",
        name: "messageEvents",
        onChange: this.setValue,
        value: this.state.messageEvents,
        size: "1",
        className: "form-control input-lg"
      }, _react.default.createElement("option", {
        value: "email"
      }, "Send by email"), this.config.sms && _react.default.createElement("option", {
        value: "sms"
      }, "Send by text message"), this.config.sms && _react.default.createElement("option", {
        value: "emailAndSms"
      }, "Send by both email and text message"), _react.default.createElement("option", {
        value: "none"
      }, "Don't notify me")), _react.default.createElement("span", null)), _react.default.createElement("div", {
        className: "form-group-help"
      }, "Receive email reminders for upcoming events that you have registered for.")), this.config.sms && (this.state.messageEvents == 'sms' || this.state.messageEvents == 'emailAndSms') ? _react.default.createElement("div", null, _react.default.createElement("div", {
        "data-field": "smsNumber",
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "smsNumber"
      }, "Mobile Phone Number"), _react.default.createElement("input", {
        className: "form-control input-lg",
        id: "smsNumber",
        name: "smsNumber",
        value: this.state.smsNumber,
        onChange: this.setValue
      }), _react.default.createElement("div", {
        className: "form-group-help"
      }, "By entering your phone number, you agree to receive multiple automated text messages related to your account. Carrier message and data rates may apply. You do not have to participate in this program to make a purchase or otherwise utilize this site. You can opt out at any time by updating your account profile preferences."))) : this.config.sms ? _react.default.createElement("input", {
        type: "hidden",
        name: "smsNumber",
        value: this.state.smsNumber
      }) : null);
    }
  }]);
  return EventNotifications;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "profile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "config", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "markInvalid", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "markValid", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setValue"), _class.prototype)), _class);
var _default = EventNotifications;
exports.default = _default;